package one.healthium.log_food.di

import one.healthium.log_food.data.image.ImageReader
import one.healthium.log_food.data.image.JsImageReader
import org.koin.dsl.module

internal actual fun logFoodPlatformModule() = module {
    single<ImageReader> { JsImageReader() }
}
